import request from '@/utils/request'

const purchaseApi = process.env.VUE_APP_PURCHASE_API

// 分页查询投标人 (所有待解密列表)
export function getToBeQuoteDecryptedPageApi(projectId, params) {
  return request(
    {
      url:
        purchaseApi +
        `/bid-hall/purchaser/kpb/projects/v2/${projectId}/offer-open/bidders/page`,
      method: 'get',
      params
    },
    false
  )
}

// 查询投标人汇总信息
export function getToBeQuoteDecryptSummaryApi(projectId, params) {
  return request(
    {
      url:
        purchaseApi +
        `/bid-hall/purchaser/kpb/projects/v2/${projectId}/offer-open/bidders/summary`,
      method: 'get',
      params
    },
    false
  )
}

// 开启报价文件解密
export function startQuoteDecryptApi(projectId, data) {
  return request({
    url:
      purchaseApi +
      `/bid-hall/purchaser/kpb/projects/v2/${projectId}/offer-open/start`,
    method: 'post',
    data
  })
}

// 分页查询投标人-唱标列表
export function getQuoteOpenMarkPageApi(projectId, params) {
  return request({
    url:
      purchaseApi +
      `/bid-hall/purchaser/kpb/projects/v2/${projectId}/offer-open/bidders/marks/page`,
    method: 'get',
    params
  })
}

// 开启报价开标一览表
export function startQuoteOpenMarkApi(projectId) {
  return request({
    url:
      purchaseApi +
      `/bid-hall/purchaser/kpb/projects/v2/${projectId}/offer-open/open-mark`,
    method: 'post'
  })
}

// 报价开标添加现场备注
export function addQuoteOpenRemarkApi(projectId, bidderId, data) {
  return request({
    url:
      purchaseApi +
      `/bid-hall/purchaser/kpb/projects/v2/${projectId}/offer-open/bidders/${bidderId}/bid-remark`,
    method: 'post',
    data
  })
}

// 报价开标结束
export function finishQuoteOpenApi(projectId, data) {
  return request({
    url:
      purchaseApi +
      `/bid-hall/purchaser/kpb/projects/v2/${projectId}/offer-open/open-bid-end`,
    method: 'post',
    data
  })
}

// 报价文件退回
export function rejectQuoteOpenFileApi(projectId, bidderId, data) {
  return request({
    url:
      purchaseApi +
      `/bid-hall/purchaser/kpb/projects/v2/${projectId}/bidders/${bidderId}/offer-file-back`,
    method: 'post',
    data
  })
}

// 评标报告-报价开标一览表查询
export function getQuoteMarkInReportApi(projectId) {
  return request({
    url:
      purchaseApi +
      `/review-hall/purchaser/kpb/projects/v2/${projectId}/offer-open/reports/bidder-mark`,
    method: 'get'
  })
}

// 开启报价文件解密
export function startQuoteOpenDecryptApi(projectId, data) {
  return request({
    url:
      purchaseApi +
      `/bid-hall/purchaser/kpb/projects/v2/${projectId}/business-open/start`,
    method: 'post',
    data
  })
}
